import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'exq-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, OnDestroy {
  id: any;
  cat: number;
  private sub: any;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id']; // (+) converts string 'id' to a number
      this.cat = +params['cat']; // (+) converts string 'id' to a number

      //console.log(this.page);
    });

    if (this.id === undefined) {
      // set value id if undefined here..
      this.router.navigate(['dashboard', 2024,]);
    }
    
    if (Number.isNaN(this.cat)) {
      // console.log(this.cat);
      this.router.navigate(['dashboard', 2024,]);
    }

  }

  onActivate(event) {
    window.scroll(0, 0);
    // document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
